import React, {useMemo} from "react";
import {RoleSelector} from "../RoleSelector";
import {CheckButton} from "../../../../designSystem/components/CheckButton";
import {PERMISSION_LABEL_MAPPING, PERMISSIONS} from "../../../../utils/constants";

const DEFAULT_PERMISSIONS = PERMISSIONS.reduce((acc, curr) => {
  acc[curr.name] = curr.default;
  return acc;
}, {});

const ALL_UNCHECKED_PERMISSIONS = PERMISSIONS.reduce((acc, curr) => {
  acc[curr.name] = false;
  return acc;
}, {});

export const PermissionEditor = ({
  role,
  userRole,
  permissions,
  onChangeRole,
  onChangePermissions,
}) => {

  const onClickTogglePlatformPermissions = () => {
    onChangeRole(role === '' ? 'worker' : '')
  }

  const onClickToggleLineOaPermissions = () => {
    onChangePermissions(isAllPermissionUnchecked ? DEFAULT_PERMISSIONS : ALL_UNCHECKED_PERMISSIONS)
  }

  const isAllPermissionUnchecked = useMemo(() => {
    return Object.values(permissions).every(value => value === false);
  }, [permissions])

  const isPlatformRole = ['god', 'admin', 'worker'].includes(role)

  return (
    <div className="rounded-xl border border-ptTeal overflow-hidden">
      <div className="p-3 text-ptTeal font-bold border-b border-ptTeal text-center">
        <i className="fa fa-lock-open mr-2"/>權限設定
      </div>
      <div className="flex flex-col gap-3 bg-white p-4">
        <CheckButton
          noBorder
          label="貼心到宅平台"
          onClick={onClickTogglePlatformPermissions}
          selected={isPlatformRole}
        />

        {isPlatformRole && (
          <div className="pl-6">
            <RoleSelector
              onChangeRole={(value: string) => onChangeRole(value)}
              selectedRole={role}
              userRole={userRole}
            />
          </div>
        )}

        <CheckButton
          noBorder
          label="屏衛LINE官方帳號"
          onClick={onClickToggleLineOaPermissions}
          selected={!isAllPermissionUnchecked}
        />

        {!isAllPermissionUnchecked && (
          <div className="pl-6">
            <div className="mb-2">
              請選擇要打開之模組:
            </div>
            <div className="flex flex-row flex-wrap">
              {Object.keys(permissions).map((permissionKey => (
                <CheckButton
                  key={permissionKey}
                  label={PERMISSION_LABEL_MAPPING[permissionKey]}
                  onClick={() => onChangePermissions({
                    ...permissions,
                    [permissionKey]: !permissions[permissionKey]
                  })}
                  selected={permissions[permissionKey]}
                />
              )))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
